module.exports = __webpack_public_path__ + "hero-mobile.28fbd2c341ccfae02bb184ad67ff0640.png";


//////////////////
// WEBPACK FOOTER
// ./components/hero/assets/hero-mobile.png
// module id = jVEy
// module chunks = 0